import { max as o, min as u } from "./math.js";
function e(i, r, n) {
  return o(i, u(r, n));
}
function m(i, r, n) {
  var t = e(i, r, n);
  return t > n ? n : t;
}
export {
  e as within,
  m as withinMaxClamp
};
